import StickyFilterToggle from './StickyFilterToggle'

export default StickyFilterToggle
